import { skipToken, useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/jobs/constants';

import { jobsQueryKeys } from './queryKeys';

/** Skipped while `jobId` is undefined. */
export const useJobInboundSettingsQuery = (jobId: string | undefined) =>
  useQuery({
    queryKey: jobsQueryKeys.inbound(jobId ?? ''),
    queryFn: jobId
      ? async () => {
          const { data } = await fetchClient.GET(endpoints.jobInbound, {
            params: { path: { id: jobId } },
          });
          return data;
        }
      : skipToken,
  });
